export default {
    meta: {
        title: '拓店宝-拓店任务',
        url: '/task',
        urlName: '拓店任务',
    }
};
